(() => {
  // Prevent double-init across rerenders
  if (window.__offerCountdownInit) return;
  window.__offerCountdownInit = true;

  const timers = new WeakMap();

  const pad = (n) => String(n).padStart(2, "0");

  const formatRemaining = (ms) => {
    let total = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(total / 86400); total -= d * 86400;
    const h = Math.floor(total / 3600);  total -= h * 3600;
    const m = Math.floor(total / 60);
    const s = total - m * 60;

    return d > 0 ? `${d}d ${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
  };

  const stop = (el) => {
    const id = timers.get(el);
    if (id) clearInterval(id);
    timers.delete(el);
  };

  const start = (el) => {
    if (timers.has(el)) return;

    const endStr = el.dataset.end;
    const end = new Date(endStr);
    const out = el.querySelector(".offer__countdown-time");
    const hideWhenEnded = el.dataset.hideWhenEnded === "true";

    if (!endStr || Number.isNaN(end.getTime())) return;

    const tick = () => {
      // If element was removed during rerender, cleanup interval
      if (!el.isConnected) return stop(el);

      const diff = end.getTime() - Date.now();

      if (diff <= 0) {
        if (hideWhenEnded) el.style.display = "none";
        else if (out) out.textContent = "00:00:00";
        return stop(el);
      }

      if (out) out.textContent = formatRemaining(diff);
    };

    tick();
    timers.set(el, setInterval(tick, 1000));
  };

  const initAll = (root = document) => {
    root.querySelectorAll("[data-offer-countdown]").forEach(start);
  };

  // Normal page load
  document.addEventListener("DOMContentLoaded", () => initAll());

  // Theme editor / section refreshes
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:unload", (e) => {
    e.target.querySelectorAll("[data-offer-countdown]").forEach(stop);
  });
})();
